import { render } from "./FooterService.vue?vue&type=template&id=76acfd97&scoped=true"
import script from "./FooterService.vue?vue&type=script&lang=js"
export * from "./FooterService.vue?vue&type=script&lang=js"

import "./FooterService.vue?vue&type=style&index=0&id=76acfd97&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76acfd97"]])

export default __exports__